import type { IpxCredentialSummaryListItem } from '@anchorbase/pillar-sdk';

export const IPX_CREDENTIAL_ACCOUNT_ID_COLLISION_MESSAGE =
    'Use a unique Account ID for this website credential.';

export function normalizeIpxCredentialAccountId(
    accountId: string,
    defaultAccountId: string
): string {
    const trimmedAccountId: string = accountId.trim();
    return trimmedAccountId.length === 0
        ? defaultAccountId.trim()
        : trimmedAccountId;
}

export function validateIpxCredentialAccountId(params: {
    readonly accountId: string;
    readonly defaultAccountId: string;
    readonly credentials: readonly IpxCredentialSummaryListItem[];
    readonly excludedCredentialUuid?: string;
}): string | undefined {
    const proposedAccountId: string = normalizeIpxCredentialAccountId(
        params.accountId,
        params.defaultAccountId
    );
    const collisionExists: boolean = params.credentials.some((credential) => {
        if (credential.credential_uuid === params.excludedCredentialUuid) {
            return false;
        }
        return (
            normalizeIpxCredentialAccountId(
                credential.account_id,
                params.defaultAccountId
            ) === proposedAccountId
        );
    });
    return collisionExists
        ? IPX_CREDENTIAL_ACCOUNT_ID_COLLISION_MESSAGE
        : undefined;
}
